export default () => {
  const { search } = window.location

  const qs = {}
  search.replace(/^\?/, '').split('&').forEach(segment => {
    const query = segment.split('=')
    if (query[0]) {
      qs[query[0]] = decodeURIComponent(query[1])
    }
  })

  return qs
}
